import React from "react";
import { Table, Tbody, Td } from "./BiBleYear.style";

const ThrityOneToSixtyOne = () => {
  return (
    <Table>
      <Tbody>
        <tr>
          <Td>31</Td>
          <Td> อพยพ 13,14</Td>
          <Td>มัทธิว 23</Td>
          <Td>Exodus 13,14</Td>
          <Td>Matthew 23</Td>

          <Td>สิ่งที่ต้องไม่ลืม</Td>
        </tr>
        <tr>
          <Td>32</Td>
          <Td>อพยพ 15,16</Td>
          <Td>สดุดี 15,16</Td>
          <Td>Exodus 15,16</Td>
          <Td>Psalms 15,16</Td>

          <Td>มีสิ่งที่ต้องสำแดงไหม?</Td>
        </tr>
        <tr>
          <Td>33</Td>
          <Td>อพยพ 17,18</Td>
          <Td>มัทธิว 24</Td>
          <Td>Exodus 17,18</Td>
          <Td>Matthew 24</Td>

          <Td>คุณได้ยินไหม?</Td>
        </tr>
        <tr>
          <Td>34</Td>
          <Td>อพยพ 19,20</Td>
          <Td>มัทธิว 25</Td>
          <Td>Exodus 19,20</Td>
          <Td>Matthew 25</Td>

          <Td>ขึ้นไปพบพระองค์</Td>
        </tr>
        <tr>
          <Td>35</Td>
          <Td>อพยพ 21,22</Td>
          <Td>สดุดี 17</Td>
          <Td>Exodus 21,22</Td>
          <Td>Psalm 17</Td>

          <Td>กฎหมายและความรัก</Td>
        </tr>
        <tr>
          <Td>36</Td>
          <Td>อพยพ 23,24</Td>
          <Td>มัทธิว 26</Td>
          <Td>Exodus 23,24</Td>
          <Td>Matthew 26</Td>

          <Td>พระเจ้าตรัส มนุษย์ทำตาม</Td>
        </tr>
        <tr>
          <Td>37</Td>
          <Td>อพยพ 25,26</Td>
          <Td>มัทธิว 27</Td>
          <Td>Exodus 25,26</Td>
          <Td>Matthew 27</Td>

          <Td>ทางเข้า - เชิญทางนี้</Td>
        </tr>
        <tr>
          <Td>38</Td>
          <Td>อพยพ 27,28</Td>
          <Td>มัทธิว 28</Td>
          <Td>Exodus 27,28</Td>
          <Td>Matthew 28</Td>

          <Td>สัมผัสกับพระเจ้า</Td>
        </tr>
        <tr>
          <Td>39</Td>
          <Td>อพยพ 29,30</Td>
          <Td>สดุดี 18</Td>
          <Td>Exodus 29,30</Td>
          <Td>Psalms 118</Td>

          <Td>ภายใต้การปกป้องคุ้มครอง</Td>
        </tr>
        <tr>
          <Td>40</Td>
          <Td>อพยพ 31,32</Td>
          <Td>กิจการ 1</Td>
          <Td>Exodus 31,32</Td>
          <Td>Acts:1</Td>

          <Td>เต็มไปด้วยฤทธิ์เดช</Td>
        </tr>
        <tr>
          <Td>41</Td>
          <Td>อพยพ 33,34</Td>
          <Td>กิจการ 2</Td>
          <Td>Exodus 33,34</Td>
          <Td>Acts 2</Td>

          <Td>การอัศจรรย์และหมายสำคัญ</Td>
        </tr>
        <tr>
          <Td>42</Td>
          <Td>อพยพ 35,36</Td>
          <Td>สดุดี 19</Td>
          <Td>Exodus 35,36</Td>
          <Td>Psalms 19</Td>

          <Td>กฎเกณฑ์และการสำแดง</Td>
        </tr>
        <tr>
          <Td>43</Td>
          <Td>อพยพ 37,38</Td>
          <Td>กิจการ 3</Td>
          <Td>Exodus 37,38</Td>
          <Td>Acts 3</Td>

          <Td>ทุกสิ่งถูกสร้างใหม่</Td>
        </tr>
        <tr>
          <Td>44</Td>
          <Td>อพยพ 39,40</Td>
          <Td>กิจการ 4</Td>
          <Td>Exodus 39,40</Td>
          <Td>Acts 4</Td>

          <Td>เหมือนกับที่พระเจ้าตรัสไว้</Td>
        </tr>
        <tr>
          <Td>45</Td>
          <Td>เลวีนิติ 1-3</Td>
          <Td>กิจการ 5</Td>
          <Td>Leviticus 1-3</Td>
          <Td>Acts 5</Td>

          <Td>อย่าถือเป็นเรื่องไม่จริงจัง</Td>
        </tr>
        <tr>
          <Td>46</Td>
          <Td>เลวีนิติ 4,5</Td>
          <Td>สดุดี 20,21</Td>
          <Td>Leviticus 4,5</Td>
          <Td>Psalms 20,21</Td>

          <Td>กฎเกณฑ์แห่งชัยชนะ</Td>
        </tr>
        <tr>
          <Td>47</Td>
          <Td>เลวีนิติ 6,7</Td>
          <Td>กิจการ 6</Td>
          <Td>Leviticus 6,7</Td>
          <Td>Acts 6</Td>

          <Td>แพงสำหรับบางคน</Td>
        </tr>
        <tr>
          <Td>48</Td>
          <Td>เลวีนิติ 8,9</Td>
          <Td>กิจการ 7</Td>
          <Td>Leviticus 8,9</Td>
          <Td>Acts 7</Td>

          <Td>ในงานรับใช้พระเจ้า</Td>
        </tr>
        <tr>
          <Td>49</Td>
          <Td>เลวีนิติ 10-12</Td>
          <Td>สดุดี 22</Td>
          <Td>Leviticus 10-12</Td>
          <Td>Psalms 22</Td>

          <Td>ยำเกรงในความบริสุทธิ์</Td>
        </tr>
        <tr>
          <Td>50</Td>
          <Td>เลวีนิติ 13,14</Td>
          <Td>กิจการ 8</Td>
          <Td>Leviticus 13,14</Td>
          <Td>Acts 8</Td>

          <Td>ชำระให้สะอาดหมดจด</Td>
        </tr>
        <tr>
          <Td>51</Td>
          <Td>เลวีนิติ 15,16</Td>
          <Td>กิจการ 9</Td>
          <Td>Leviticus 15,16</Td>
          <Td>Acts 9</Td>

          <Td>เวลาหนึ่ง ณ ที่แห่งหนึ่ง</Td>
        </tr>
        <tr>
          <Td>52</Td>
          <Td>เลวีนิติ 17,18</Td>
          <Td>กิจการ 10</Td>
          <Td>Leviticus 17,18</Td>
          <Td>Acts 10</Td>

          <Td>พระเจ้าทรงประสงค์สิ่งใด</Td>
        </tr>
        <tr>
          <Td>53</Td>
          <Td>เลวีนิติ 19,20</Td>
          <Td>สดุดี 23,24</Td>
          <Td>Leviticus 19,20</Td>
          <Td>Psalms 23,24</Td>

          <Td>ทรงนำอย่างใกล้ชิด</Td>
        </tr>
        <tr>
          <Td>54</Td>
          <Td>เลวีนิติ 21,22</Td>
          <Td>กิจการ 11</Td>
          <Td>Leviticus 21,22</Td>
          <Td>Acts 11</Td>

          <Td>กลับใจและมีชีวิต</Td>
        </tr>
        <tr>
          <Td>55</Td>
          <Td>เลวีนิติ 23,24</Td>
          <Td>กิจการ 12</Td>
          <Td>Leviticus 23,24</Td>
          <Td>Acts 12</Td>

          <Td>จงชื่มชมยินดีอยู่เสมอ</Td>
        </tr>
        <tr>
          <Td>56</Td>
          <Td>เลวีนิติ 25,26</Td>
          <Td>สดุดี 25</Td>
          <Td>Leviticus 25,26</Td>
          <Td>Psalms 25</Td>

          <Td>รู้ดีว่าอะไรดี - ดังนั้น...</Td>
        </tr>
        <tr>
          <Td>57</Td>
          <Td>
            เลวีนิติ 27
            <br />
            กันดารวิถี 1
          </Td>
          <Td>กิจการ 13</Td>
          <Td>
            Leviticus 27
            <br />
            Numbers 1
          </Td>
          <Td>Acts 13</Td>

          <Td>มีเสรีเพื่อรับใช้</Td>
        </tr>
        <tr>
          <Td>58</Td>
          <Td>กันดารวิถี 2,3</Td>
          <Td>กิจการ 14</Td>
          <Td>Numbers 2,3</Td>
          <Td>Acts 14</Td>

          <Td>นับเผ่านับคน</Td>
        </tr>
        <tr>
          <Td>59</Td>
          <Td>กันดารวิถี 4,5</Td>
          <Td>กิจการ 15</Td>
          <Td>Numbers 4,5</Td>
          <Td>Acts 15</Td>

          <Td>พระเจ้าผู้ทรงละเอียดรอบคอบ</Td>
        </tr>
        <tr>
          <Td>60</Td>
          <Td>กันดารวิถี 6,7</Td>
          <Td>สดุดี 26,27</Td>
          <Td>Numbers 6,7</Td>
          <Td>Psalms 26,27</Td>

          <Td>ติดต่อถึงกันและกัน</Td>
        </tr>
        <tr>
          <Td>61</Td>
          <Td>กันดารวิถี 8,9</Td>
          <Td>กิจการ 16</Td>
          <Td>Numbers 8,9</Td>
          <Td>Acts 16</Td>

          <Td>ถ่ายทอดคำสอนต่อๆ กันไป</Td>
        </tr>
      </Tbody>
    </Table>
  );
};

export default ThrityOneToSixtyOne;
